<script lang="ts">
    import Header from "../Layout/Header.svelte";
    import {link} from 'svelte-spa-router'

    export let errorCode;
</script>

<svelte:head>
    <title>Chrono Chape - Erreur {errorCode}</title>
</svelte:head>

<Header/>

<h2 class="title is-2 has-text-centered mb-6">Erreur {errorCode}</h2>

<div class="p-6 m-6">
    {#if errorCode === "404"}
        <p class="has-text-centered">La ressource que vous recherchez n'a pas été trouvée. Veuillez réessayer.</p>
    {:else if  errorCode === "401"}
        <p class="has-text-centered">Vous n'avez pas les droits pour accéder à la ressource. Veuillez vous authentifier.</p>
    {:else if  errorCode === "500"}
        <p class="has-text-centered">Le serveur a rencontré une situation qu'il ne sait pas traiter. Veuillez réessayer.</p>
    {/if}
</div>
<div class="is-justify-content-center is-flex">
    <a href="/" use:link class="button is-info link">Retour à l'accueil</a>
</div>